import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "label", "className", "iconKey", "rows"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { twMerge } from 'tailwind-merge';
import React, { forwardRef } from 'react';
import Icon from './Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BaseTextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    iconKey = _ref.iconKey,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 3 : _ref$rows,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex w-full flex-col gap-y-1.5",
    children: [label ? /*#__PURE__*/_jsx("label", {
      htmlFor: id,
      className: "flex text-sm font-bold text-gray-800",
      children: label
    }) : null, /*#__PURE__*/_jsxs("div", {
      className: "relative w-full rounded-sm",
      children: [/*#__PURE__*/_jsx("textarea", _objectSpread({
        id: id,
        ref: ref,
        rows: rows
        // Only when there is no visible label to point at:
        // otherwise the label above already names the field,
        // and a second name would override what is on screen.
        ,
        "aria-label": label ? undefined : props.placeholder,
        className: twMerge('form-input focus-ring block w-full rounded-md border-0 bg-gray-100 p-3 text-sm/4 text-gray-800 placeholder:text-gray-500 read-only:bg-gray-100 focus:ring-0 disabled:text-gray-400 dark:bg-gray-100 dark:disabled:text-gray-600', className, iconKey ? 'pe-10' : '')
      }, props)), iconKey ? /*#__PURE__*/_jsx("div", {
        className: "pointer-events-none absolute inset-y-0 end-0 flex items-center pe-3 text-gray-600",
        children: /*#__PURE__*/_jsx(Icon, {
          iconKey: iconKey,
          size: "24px"
        })
      }) : null]
    })]
  });
});
export default BaseTextArea;